import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { FailureCause } from './failure-cause';

export class FailureMechanismReason implements ViewModel {
  friendlyTypeNameSingular: string = 'Failure Mechanism Reason';
  apiRoute: string = CONFIG.apiRoutes.failureMechanismReason;

  selected: boolean;
  id: string;
  summary: string;
  isSaved: boolean = false;
  failureCauses: FailureCause[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.summary = data.summary;
    this.isSaved = data.isSaved;

    if (data.failureCauses) {
      this.failureCauses = data.failureCauses.map((details: FailureCause) => {
        const newFailureCause = new FailureCause();
        newFailureCause.loadFromJson(details);
        return newFailureCause;
      });
    }
  }
}
